$(window).on('load resize orientationchange', function(){
	if ($('.banner').length) {
		var windowW = $(window).width();
		var breakpointXL = 2240;
		
		if (windowW < breakpointXL) {
		
			var bannerPos = $('.banner').offset().top;
			var bannerOH = $('.banner').outerHeight(true);
			var bannerH = bannerPos + bannerOH;

			var mainHeaderPos = $('.main__header').offset().top;
			var mainHeaderOH = $('.main__header').outerHeight();
			var mainHeaderH = mainHeaderPos + mainHeaderOH;

			var mb = bannerH - mainHeaderH;
			if (mb < 0) {
				mb = 50;
			}

			$('.main__header').css({
				'margin-bottom': mb
			});

		} else {
			$('.main__header').css({
				'margin-bottom': 74
			});
		}
	}
});